import { MAX_COUNT_TO_RENDER } from '../helpers/couponPeekConsts';
import { Icon } from '@fluentui/react/lib/Icon';
import * as React from 'react';

import styles from './CouponPreview.scss';

export interface CouponPreviewWellProps {
    validCouponIndexes: number[];
    couponContainerClass: string;
    rowId: string;
}

export default function renderCouponPlaceholder(props: CouponPreviewWellProps): JSX.Element {
    const couponCountsToRender = Math.min(MAX_COUNT_TO_RENDER, props.validCouponIndexes.length);
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2739 (18,5): Type 'Element[]' is missing the following properties from type 'ReactElement<any, any>': type, props, key ...
    // @ts-expect-error
    return Array.apply(null, Array(couponCountsToRender)).map(text => (
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (22,14): Type 'unknown' is not assignable to type 'Key | undefined'.
        // @ts-expect-error
        <div key={text}>
            <Icon iconName={''} className={styles.icon} />
        </div>
    ));
}
